export const VideoAiExamplePrompt = [
  "A derelict spaceship drifts silently through a rainbow nebula, its hull scarred and glowing with faint blue energy veins as debris floats past in slow motion. Wide anamorphic shot, cold metallic tones, lens flare.",

  "A colossal space station rotates slowly against a backdrop of a dying star, solar flares rippling across its surface in fiery orange light. Cinematic wide shot, dramatic rim lighting.",

  "Astronauts float weightless inside a cracked observation dome as an alien planet’s rings fill the entire sky above them. Slow dolly-in, soft blue Earthlight, quiet awe.",

  "A fleet of glass starships glides silently through a field of frozen asteroids, sunlight refracting into prisms across their hulls. Wide tracking shot, crystalline reflections.",

  "Deep inside a wormhole, streams of light twist and fold into impossible geometry as a lone probe tumbles through the vortex. Hyperlapse motion, surreal color shifts.",

  "A terraformed moon base glows beneath twin suns, greenhouses domes shimmering with condensation as shuttles descend through orange haze. Golden hour lighting, wide establishing shot.",

  "An ancient alien monolith floats motionless above a crimson ocean, lightning arcing between it and the water’s surface. Low-angle hero shot, thunderous atmosphere.",

  "A cryo-chamber hums softly as frost creeps across its glass, reflecting the swirling aurora of a gas giant outside the window. Slow push-in, cool blue palette.",

  "A massive generation ship drifts past a supernova remnant, its lights flickering like a distant city in the void. Extreme wide shot, epic scale, deep space blacks.",

  "Inside a zero-gravity garden, bioluminescent plants drift and sway as starlight filters through a transparent dome ceiling. Dreamlike slow motion, soft glow.",

  "A dragon made of living flame soars over a floating castle, waterfalls flowing upward into the clouds below its wings. Epic wide shot, golden-orange firelight.",

  "Deep in an enchanted forest, ancient trees pulse with glowing runes as a spectral deer walks silently between them. Misty atmosphere, soft moonlight.",

  "A wizard’s tower spirals into storm clouds, lightning crackling around its spire as ravens circle in formation. Dramatic low-angle shot, deep purple sky.",

  "An army of knights in silver armor marches across a bridge of solid light suspended between two floating islands. Wide cinematic shot, heroic orchestral pacing.",

  "A phoenix bursts from a bed of embers atop a mountain temple, feathers scattering into glowing sparks against the night sky. Slow motion, fiery particle effects.",

  "A crystal cavern glows with veins of magic, illuminating an ancient sleeping giant curled among the stalactites. Moody torchlight, atmospheric fog.",

  "A witch’s cottage sits at the edge of a glowing swamp, will-o’-the-wisps drifting between twisted, luminous trees. Eerie green-blue palette, slow tracking shot.",

  "A colossal stone golem awakens in a moss-covered ruin, cracks of golden light spreading across its body as it rises. Low camera angle, rumbling atmosphere.",

  "Elven archers stand atop a waterfall city carved into a cliffside, mist rising as sunlight breaks through the canopy above. Wide establishing shot, lush greens.",

  "A celestial unicorn gallops across a field of floating flowers under a sky filled with two overlapping moons. Dreamy soft-focus, pastel color grade.",

  "Bioluminescent whales glide slowly through a glowing coral trench deep beneath the sea, light pulsing along their bodies. Dreamlike slow motion, teal-magenta palette.",

  "A sunken city stretches across the ocean floor, its towers overgrown with coral as schools of glowing fish weave through crumbling archways. Wide tracking shot, deep blue tones.",

  "A giant kraken uncoils from the depths as lightning flashes above the storm-tossed surface of the sea. Dramatic low-angle shot, dark stormy palette.",

  "Jellyfish drift like lanterns through a moonlit bay, their glow reflecting off gentle rippling waves. Slow rising crane shot, soft cyan lighting.",

  "An underwater waterfall cascades over a coral cliff into an even deeper trench, sunlight piercing through in golden shafts. Wide cinematic shot, layered depth.",

  "A mermaid swims alongside a pod of dolphins through a kelp forest lit by shafts of sunlight from above. Fluid tracking shot, natural warm light.",

  "Ice floes drift above a glowing arctic reef where seals dart between towering underwater icebergs. Cool blue tones, slow panning shot.",

  "A tidal wave frozen mid-motion towers over a coastal village at dawn, sunlight catching every droplet suspended in the air. Surreal slow motion, golden light.",

  "Deep-sea vents release shimmering heat plumes as strange luminous creatures drift past ancient volcanic rock formations. Moody dark palette, dramatic lighting.",

  "A ghost ship rests on the ocean floor, its sails still billowing gently in the current as fish swim through broken windows. Eerie blue-green atmosphere.",

  "Giant glowing mushrooms tower over a misty ancient forest, fireflies swirling between ferns in the fading light. Macro-to-wide pull-back, warm forest lighting.",

  "A waterfall cascades through a canyon lined with autumn trees, golden leaves drifting on the wind in slow motion. Wide cinematic shot, warm amber tones.",

  "A herd of bioluminescent deer moves silently through a moonlit meadow, their antlers glowing faintly blue. Dreamlike atmosphere, soft focus.",

  "Sunbeams pierce through a dense redwood canopy, illuminating drifting pollen and mist rising from the forest floor. Slow vertical tilt, natural warm light.",

  "A field of glowing flowers stretches to the horizon beneath a sky filled with drifting cherry blossoms. Wide pastoral shot, pastel color grade.",

  "Lightning illuminates a storm rolling over vast wheat fields, wind rippling across the grain in dramatic waves. Wide dynamic shot, high contrast.",

  "A hidden waterfall pours into a crystal-clear pool surrounded by glowing moss and ancient stone ruins. Slow dolly-in, lush green palette.",

  "Northern wildflowers bloom rapidly in time-lapse motion across a mountain meadow beneath drifting clouds. Timelapse cinematography, vibrant colors.",

  "A lone tree stands atop a cliff overlooking an endless valley shrouded in morning fog, sunrise breaking through. Wide establishing shot, golden hour.",

  "Fireflies rise in a spiraling swarm above a quiet lake as the last light of sunset fades into twilight. Slow rising shot, warm-to-cool color transition.",

  "A colossal cathedral built entirely of light hovers in deep space, planets visible through its translucent walls. Epic scale, volumetric god rays.",

  "A nebula slowly swirls into the shape of a blooming flower, colors shifting from violet to gold. Hyperlapse motion, surreal cosmic palette.",

  "A figure of pure starlight walks across a field of drifting galaxies, footsteps leaving trails of stardust. Dreamlike slow motion, ethereal glow.",

  "Time itself seems to bend as clock fragments drift through a swirling void of golden light. Surreal abstract visuals, warm glowing tones.",

  "A staircase made of light spirals endlessly upward into a starlit void, each step shimmering as it’s touched. Slow vertical camera pull, celestial atmosphere.",

  "Twin galaxies collide in slow motion, their spiral arms merging into a brilliant burst of new stars. Extreme wide shot, dramatic cosmic colors.",

  "A single feather drifts through a cosmic void, transforming into a flock of glowing birds as it falls. Surreal slow motion, dreamlike transitions.",

  "An hourglass floats in space, its falling sand transforming into a stream of stars as it pours. Macro cinematic shot, deep space background.",

  "A glowing tree of life grows out of a swirling nebula, its branches reaching across the stars. Wide symbolic shot, warm golden light.",

  "Reflections of an entire galaxy ripple across the surface of a still cosmic ocean. Slow tracking shot, mirror-like reflections.",

  "Rain-soaked neon streets stretch into infinity as flying cars weave between towering holographic billboards. Moody neon-noir lighting, wet reflections.",

  "A lone figure walks through a crowded night market lit by shifting holographic signs in a dozen languages. Low tracking shot, vibrant neon palette.",

  "A massive mech strides through a flooded cyberpunk city, its reflection rippling across the water below. Wide dramatic shot, cold blue-pink tones.",

  "Drones swarm above a skyline of glowing skyscrapers as a storm rolls in over the city at dusk. Wide establishing shot, dramatic clouds.",

  "A hacker’s apartment glows with dozens of floating holographic screens reflecting off rain-streaked windows. Intimate close shot, cool cyan lighting.",

  "A bullet train speeds through a neon-lit tunnel beneath a city, light trails streaking past the windows. Fast tracking shot, motion blur.",

  "A rooftop garden sits above a sprawling megacity, bioluminescent plants glowing against the smog-filled skyline. Wide contrast shot, warm-cool color clash.",

  "Street performers project holographic illusions into a crowded plaza as neon rain falls softly. Slow panning shot, vibrant saturated colors.",

  "An android stands motionless in an abandoned server room, dust particles floating in shafts of blue emergency light. Moody atmospheric shot, minimalist framing.",

  "A vertical city stretches endlessly upward, elevators of light gliding between platforms suspended in the clouds. Extreme wide vertical shot, futuristic scale.",

  "An endless desert glows under a meteor shower, sand shimmering like glass beneath the streaking lights. Wide lens, deep contrast, cinematic grain.",

  "A caravan of camels crosses golden dunes at sunset, their shadows stretching endlessly across the sand. Wide cinematic shot, warm amber tones.",

  "Ancient ruins emerge from shifting sands as a sandstorm rolls across the horizon in slow motion. Dramatic wide shot, dusty golden atmosphere.",

  "A mirage shimmers above the dunes, revealing the faint outline of a floating oasis city. Surreal heat-distortion effect, warm palette.",

  "A lone rider gallops across moonlit dunes, sand kicking up in silver trails behind the horse. Wide tracking shot, cool nighttime tones.",

  "Bioluminescent scorpions scuttle across glowing sand dunes beneath a sky full of shooting stars. Macro-to-wide shot, deep blue night palette.",

  "A colossal stone sphinx sits half-buried in the desert, wind slowly revealing more of its ancient carved face. Slow reveal shot, golden hour lighting.",

  "Desert canyons glow orange and red at sunset as a lone eagle soars between the towering rock walls. Wide aerial shot, dramatic natural lighting.",

  "A sandstorm swirls around an ancient pyramid, lightning flashing within the storm clouds above it. Dramatic wide shot, high contrast.",

  "An oasis appears at dawn, palm trees reflecting in still water surrounded by endless golden dunes. Wide establishing shot, soft sunrise light.",

  "Massive ice canyons glow beneath shifting auroras, the northern lights rippling in waves of green and violet. Slow crane shot, icy blue grade.",

  "A lone wolf howls atop a snow-covered ridge as the aurora borealis dances across the star-filled sky. Wide cinematic shot, cold moody lighting.",

  "Glaciers calve into a frozen sea, sending waves of ice crashing outward in slow motion. Dramatic wide shot, stark white-blue palette.",

  "A frozen waterfall glows faintly blue at twilight, icicles reflecting the last light of the setting sun. Slow dolly-in, cool atmospheric tones.",

  "An ice cave glimmers with trapped light, its crystalline walls reflecting a thousand shades of blue. Intimate tracking shot, ethereal glow.",

  "A polar bear walks across a vast ice field beneath a sky streaked with shifting auroras. Wide establishing shot, quiet cinematic pacing.",

  "Snow falls silently over an abandoned arctic research station, its lights flickering against the polar night. Moody atmospheric shot, cold color grade.",

  "A frozen lake cracks slowly under starlight, sending glowing fractures spreading across its surface. Macro-to-wide shot, surreal blue lighting.",

  "Icebergs drift silently through a fjord at dawn, mist rising off the water in soft golden light. Wide serene shot, pastel morning tones.",

  "A reindeer herd moves across a snow-covered tundra as the aurora shifts overhead in slow, sweeping arcs. Wide cinematic shot, cold ethereal palette.",

  "A forest of giant clockwork trees ticks and hums, gears turning as brass fireflies swirl between branches. Warm brass tones, intricate detail.",

  "An airship drifts above a Victorian-era city, steam trailing from its engines as gears turn along its hull. Wide establishing shot, warm sepia tones.",

  "A colossal mechanical elephant walks through a desert, steam venting rhythmically from pipes along its back. Wide dramatic shot, dusty golden light.",

  "Inside a vast clock tower, thousands of gears turn in perfect synchronization as light streams through stained glass. Intimate tracking shot, warm amber glow.",

  "A steam-powered submarine surfaces in a foggy harbor, brass fittings gleaming under lantern light. Moody atmospheric shot, cool-warm contrast.",

  "An inventor’s workshop glows with the light of a hundred small mechanical fireflies hovering above cluttered desks. Intimate close shot, warm candlelight.",

  "A brass automaton walks slowly through a rain-soaked cobblestone street, steam rising from its joints. Cinematic tracking shot, moody Victorian atmosphere.",

  "Giant gears turn beneath a floating steampunk city, sunlight glinting off polished brass and copper. Wide aerial shot, warm metallic tones.",

  "A clockwork owl perches on a windowsill overlooking a city of smokestacks and airships at dusk. Intimate wide shot, warm sunset palette.",

  "An enormous steam engine roars to life inside a cathedral-like factory, light streaming through smoke and steam. Dramatic wide shot, industrial atmosphere.",

  "An infinite library spirals upward into a starlit void, books floating and pages dissolving into light. Slow vertical camera pull, candlelit warmth against deep space black.",

  "A giant whale made of clouds swims slowly across a golden sunset sky above a quiet village. Wide dreamlike shot, warm pastel tones.",

  "Ink flows from an old quill and rises into the air, forming shifting shapes of birds and mountains. Surreal macro shot, warm sepia lighting.",

  "A door standing alone in an open field opens to reveal a swirling galaxy on the other side. Wide symbolic shot, dramatic contrast.",

  "A giant tortoise carries an entire miniature forest ecosystem on its back as it walks through misty wetlands. Wide fantastical shot, lush green palette.",

  "Constellations descend from the night sky and take the form of mythical animals walking across a moonlit field. Dreamlike slow motion, cool silver light.",

  "A candle’s flame grows into a swirling vortex of golden light, revealing glimpses of distant worlds within it. Macro cinematic shot, warm glowing tones.",

  "An ancient tree’s roots pulse with light as glowing spirits drift up from the ground around its trunk. Moody atmospheric shot, ethereal green-gold glow.",

  "A paper boat sails across a puddle that reflects an entire galaxy instead of the sky above. Macro-to-wide surreal shot, cosmic reflection.",

  "A storyteller’s silhouette sits before a fire as shadows on the cave wall come alive, forming entire worlds. Warm firelight, intimate cinematic framing."
];